var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotaltxn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_548_2210)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 27.5,
    r: 27.5,
    fill: "#BCC8FD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_2210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6376 26.8474V41.2066C40.6376 41.5671 40.3454 41.8593 39.9849 41.8593H25.6258C25.2653 41.8593 24.9731 41.5671 24.9731 41.2066V34.027H23.6677V41.2066C23.6677 42.288 24.5444 43.1647 25.6258 43.1647H39.985C41.0664 43.1647 41.9431 42.288 41.9431 41.2066V26.8474H40.6376Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2366 29.458H22.3624C19.8404 29.4613 17.7968 31.5049 17.7935 34.0269H19.0989C19.101 32.2254 20.5609 30.7656 22.3623 30.7634H28.2365C28.9575 30.7634 29.5419 31.3479 29.5419 32.0688C29.5419 32.7897 28.9575 33.3741 28.2365 33.3741H22.3623V34.6795H28.2365C29.6784 34.6795 30.8473 33.5106 30.8473 32.0687C30.8473 30.6269 29.6784 29.458 28.2366 29.458Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4882 31.4163C16.1277 31.4163 15.8354 31.7085 15.8354 32.069V32.7217H19.0989V31.4163H16.4882Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3624 40.5537C20.5609 40.5516 19.1011 39.0918 19.0989 37.2903H17.7935C17.7968 39.8122 19.8404 41.8559 22.3624 41.8591H24.3204V40.5538H22.3624V40.5537Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8354 38.5957V39.2484C15.8354 39.6089 16.1277 39.9011 16.4882 39.9011H19.0989V38.5958H15.8354V38.5957Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6376 13.1409H36.0688C34.627 13.1409 33.4581 14.3098 33.4581 15.7516C33.4581 17.1935 34.627 18.3624 36.0688 18.3624H41.9431V17.057H36.0688C35.3479 17.057 34.7635 16.4726 34.7635 15.7516C34.7635 15.0307 35.3479 14.4463 36.0688 14.4463H40.6377C42.4392 14.4484 43.899 15.9083 43.9011 17.7097H45.2065C45.2032 15.1878 43.1596 13.1441 40.6376 13.1409Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5118 15.0989H43.9011V16.4042H47.1646V15.7516C47.1646 15.3911 46.8723 15.0989 46.5118 15.0989Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9011 20.9731C43.899 22.7746 42.4391 24.2344 40.6377 24.2366H36.0688V25.542H40.6377C43.1596 25.5388 45.2033 23.4951 45.2065 20.9731H43.9011Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9011 22.2786V23.584H46.5119C46.8724 23.584 47.1646 23.2917 47.1646 22.9313V22.2786H43.9011V22.2786Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0366 17.5302L37.7808 17.8859C38.2916 19.6909 37.9991 21.6286 36.9783 23.2024C35.0213 26.2197 30.9888 27.0793 27.9714 25.1223C24.9541 23.1653 24.0945 19.1328 26.0515 16.1154C28.0086 13.0981 32.041 12.2385 35.0584 14.1955L35.7712 13.1016C34.5009 12.2756 33.0181 11.8357 31.5028 11.8354C27.1771 11.8347 23.6699 15.3407 23.6691 19.6664C23.6684 23.9921 27.1744 27.4993 31.5 27.5C32.2192 27.4995 32.935 27.4 33.6271 27.2043C37.7923 26.0267 40.2143 21.6954 39.0366 17.5302Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1946 17.7097H32.8054V16.4043H30.1946C29.1132 16.4043 28.2366 17.281 28.2366 18.3624C28.2366 19.4438 29.1132 20.3204 30.1946 20.3204H32.8054V19.0151H30.1946C29.8342 19.0151 29.5419 18.7228 29.5419 18.3624C29.5419 18.0019 29.8342 17.7097 30.1946 17.7097Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8054 19.0151H30.1946V20.3205H32.8054C33.1658 20.3205 33.4581 20.6127 33.4581 20.9732C33.4581 21.3337 33.1658 21.6259 32.8054 21.6259H30.1946C29.8341 21.6259 29.5419 21.3337 29.5419 20.9732H28.2365C28.2365 22.0546 29.1132 22.9313 30.1946 22.9313H32.8054C33.8868 22.9313 34.7634 22.0546 34.7634 20.9732C34.7634 19.8918 33.8868 19.0151 32.8054 19.0151Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1526 22.2786H30.8473V24.2366H32.1526V22.2786Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1526 15.0989H30.8473V17.0569H32.1526V15.0989Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6258 25.542C24.5444 25.542 23.6677 26.4187 23.6677 27.5001V30.1108H24.9731V27.5001C24.9731 27.1396 25.2653 26.8474 25.6258 26.8474H28.2366V25.542H25.6258Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2365 26.1946H26.9312V30.1107H28.2365V26.1946Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 26.8474V31.4163H30.1946V32.7216H32.1527C32.5132 32.7216 32.8054 32.4294 32.8054 32.0689V26.8474H31.5Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3323 39.2485H35.4161V40.5539H39.3323V39.2485Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3323 36.6377H35.4161V37.9431H39.3323V36.6377Z",
    fill: "#0D6EFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_548_2210",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_548_2210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_548_2210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_2210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3291,
    height: 31.3291,
    fill: "white",
    transform: "translate(15.8354 11.8354)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaltxn);
export default __webpack_public_path__ + "static/media/totaltxn.052093c521e6020f54c9a3bb1c3d7f10.svg";
export { ForwardRef as ReactComponent };